;(function (angular, _, moment) {
  'use strict'

  var LOGIC = ['__OR', '__AND']

  var OPERATORS = [
    { value: '_eq', label: 'est exactement égal à' },
    { value: '_ne', label: 'n\'est pas égal à' },
    { value: '_gt', label: 'est supérieur à' },
    { value: '_gte', label: 'est supérieur ou égal à' },
    { value: '_lt', label: 'est inférieur à' },
    { value: '_lte', label: 'est inférieur ou égal à' }]

  angular
    .module('kilo.common.directives')
    .directive('conditionsDragDrop', function () {
      return {
        controller: function () {},
        scope: {},
        controllerAs: 'dragDropCtrl',
        bindToController: {
          conditionsDrag: '=',
          conditionsDrop: '&',
          conditionsOnDrag: '&'
        },
        link: function (scope, element) {
          var el = element[0]
          if (scope.dragDropCtrl.conditionsDrag) {
            el.draggable = true

            el.addEventListener(
              'dragstart',
              function (e) {
                e.dataTransfer.effectAllowed = 'move'
                e.dataTransfer.setData('Text', scope.dragDropCtrl.conditionsDrag)
                this.classList.add('drag')
                if (scope.dragDropCtrl.conditionsOnDrag) {
                  scope.dragDropCtrl.conditionsOnDrag({
                    $event: e,
                    $data: scope.dragDropCtrl.conditionsDrag
                  })
                }
                return false
              },
              false
            )

            el.addEventListener(
              'dragend',
              function (e) {
                this.classList.remove('drag')
                return false
              },
              false
            )
          }

          if (scope.dragDropCtrl.conditionsDrop) {
            el.addEventListener(
              'drop',
              function (e) {
                e.preventDefault()
                e.stopPropagation()
                if (e.stopPropagation) e.stopPropagation()
                this.classList.remove('over')
                scope.dragDropCtrl.conditionsDrop({ $data: e.dataTransfer.getData('Text'), $event: e })
                return false
              },
              false
            )
          }
        }
      }
    })
    .directive('conditions', Conditions)
    .filter('condition', function () {
      return function (value) {
        switch (value) {
          case '__OR':
            return 'OU'
          case '__AND':
            return 'ET'
        }
      }
    })
    .filter('operator', function () {
      return function (value) {
        return _.get(_.find(OPERATORS, { value: value }), 'label')
      }
    })
    .filter('searchTag', function () {
      return function (value) {
        switch (value) {
          case 'account':
            return 'Compte client'
          case 'siret':
            return 'Siret'
          case '_id':
            return 'Balance'
          case 'client':
          case 'shippingEntities':
            return 'Client'
          case 'delivery':
            return 'Zone de livraison'
          case 'invoiceRef':
            return 'Facture'
          case 'address':
            return 'Adresse'
          case 'city':
            return 'Ville'
          case 'date':
            return 'Date d\'émission'
          case 'dueDate':
            return 'Date d\'échéance'
          case 'signDate':
            return 'Date de signature'
          case 'owner':
            return 'Créateur'
          case 'payment':
            return 'Paiement'
          case 'postalCode':
            return 'Code postal'
          case 'appart':
            return 'Appartement'
          case 'ref':
            return 'Référence'
          case 'billingEntity':
            return 'Adresse de facturation'
          case 'tenant':
            return 'Locataire'
          case 'type':
            return 'Type'
          case 'state':
            return 'État'
          case 'title':
            return 'Titre'
          case 'tags':
            return 'Tag'
          case 'priority':
            return 'Priorité'
          case 'number':
            return 'Numéro client'
          case 'invoiceNumber':
            return 'Numéro de facture'
          case 'quoteNumber':
            return 'Numéro de devis'
          case 'creditNoteNumber':
            return 'Numéro d\'avoir'
          case 'status':
            return 'État'
          case 'createdAt':
            return 'Date de création'
          case 'subContractor':
            return 'Sous-traitant'
          case 'totalMin':
            return 'Montant total HT minimum'
          case 'totalMax':
            return 'Montant total HT maximum'
          case 'fullTotalMin':
            return 'Montant total TTC minimum'
          case 'integratedOnChorus':
            return 'Intégrée sur CHORUS'
          case 'fullTotalMax':
            return 'Montant total TTC maximum'
          case 'discountedTotalHtMin':
            return 'Montant total HT minimum'
          case 'discountedTotalHtMax':
            return 'Montant total HT maximum'
          case 'discountMin':
            return 'Remise minimum'
          case 'discountMax':
            return 'Remise maximum'
          case 'category':
            return 'Categorie'
          case 'priceMin':
            return 'Prix minimum'
          case 'priceMax':
            return 'Prix maximum'
          case 'label':
            return 'Désignation'
          case 'bpu':
            return 'BPU'
          case 'interventionsCount':
            return 'Nombre d\'interventions liées'
          case 'invoiceDeposit':
            return 'Acompte'
          case 'cancelByUser':
            return 'Facture annulée'
          default:
        }
      }
    })
  Conditions.$inject = ['$compile']

  function Conditions ($compile) {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        conditions: '=',
        availableFields: '=',
        onRemove: '&',
        onChange: '&',
        depth: '=?'
      },
      templateUrl: '/app/common/directives/conditions/conditions.html',
      controllerAs: 'ctrl',
      controller: ['$scope', '$element', '$filter', function ($scope, $element, $filter) {
        var self = this
        self.$onInit = () => {
          _.extend(self, {
            remove: remove,
            removeMe: removeMe,
            isEmpty: isEmpty,
            getLabel: getLabel,
            getIcon: getIcon,
            getFlow: getFlow,
            changeCondition: changeCondition,
            negate: negate,
            onDrop: onDrop,
            stringify: JSON.stringify
          })
          init()
        }
        self.depth = self.depth || 0
        self.operators = OPERATORS
        $scope.$watch(function () { return self.conditions }, init, true)

        function init () {
          if (!self.conditions || _.isEmpty(self.conditions)) {
            self.value = self.key = self.operator = self.logic = null
            return
          }
          /** If the operation is a AND or a OR */
          self.logic = _.findKey(self.conditions,
            function (v, k) {
              return isLogic(k)
            })

          /* Let the user change the logic operator */
          self.availableLogic = _.filter(LOGIC, function (l) { return l !== self.logic })
        }

        function negate () {
          if (getElement(self.conditions.key).negate === false) return
          self.conditions.__NOT = !self.conditions.__NOT
          init()
          self.onChange()
        }

        function changeCondition (newOperator, index) {
          /* If we have only two operands on the logic operator, we just need to upgrade the key of the logic op */
          if (self.conditions[self.logic] && self.conditions[self.logic].length === 2) {
            self.conditions[newOperator] = self.conditions[self.logic]
            delete self.conditions[self.logic]
          } else if (self.conditions[self.logic] && self.conditions[self.logic].length > 2) {
            /* change the condition on just the two operands around the operator clicked by the user */
            var deleted = self.conditions[self.logic].splice(index, 2)
            var obj = {}
            obj[newOperator] = deleted
            self.conditions[self.logic].splice(index, 0, obj)
          }
          init()
          self.onChange()
        }

        function getFlow (depth) {
          var depth = depth || self.depth
          return depth % 2 ? 'column' : 'row'
        }

        function isLogic (k) {
          return _.includes(LOGIC, k)
        }

        function isEmpty () {
          return !self.conditions || !Object.keys(self.conditions).length
        }

        function remove (index) {
          if (self.logic && self.conditions[self.logic] && Array.isArray(self.conditions[self.logic])) {
            self.conditions[self.logic].splice(index, 1)
          }
          if (!_.get(self, ['conditions', self.logic, 'length'])) self.onRemove()
          self.onChange()
        }

        function removeMe () {
          self.conditions = {}
          self.onRemove()
        }

        function getElement (type) {
          switch (type) {
            case 'account' :
              return {
                icon: 'account-box-outline',
                label: function (value) {
                  if (_.get(value, 'label')) return value.label
                  return (value.v.label) ? value.v.label : value.v
                } }
            case 'siret':
              return {
                icon: 'account-card-details',
                label: function (value) {
                  if (_.get(value, 'label')) return value.label
                  return (value.v.label) ? value.v.label : value.v
                } }
            case '_id':
              return { icon: 'scale-balance', label: function (v) { return 'Balance ' + v.type } }
            case 'category':
              return { icon: 'group', label: 'v' }
            case 'shippingEntities':
              return { icon: 'map-marker-radius', label: 'v' }
            case 'referers':
              return { icon: 'account-alert', label: 'fullname' }
            case 'address':
              return { icon: 'map-marker', label: 'value.fullAddress' }
            case 'addressAsIs':
              return { icon: 'map-marker', label: function (v) { return '"' + v.value + '"' } }
            case 'city':
              return { icon: 'map-marker', label: 'value' }
            case 'owner':
              return { icon: 'account-alert', label: 'lastname firstname' }
            case 'postalCode':
              return { icon: 'map-marker', label: 'v' }
            case 'appart':
              return { icon: 'map-marker', label: 'v' }
            case 'orders':
              return { icon: 'book', label: 'v' }
            case 'reference':
            case 'ref':
              return { icon: 'book', label: 'v' }
            case 'type':
              return { icon: 'pin', label: 'label' }
            case 'state':
              return { icon: 'cube-send', label: 'label' }
            case 'payment':
              return { icon: 'cash', label: 'label' }
            case 'label':
              return { icon: 'account',
                label: function (value) {
                  if (_.get(value, 'label')) return value.label
                  return (value.v.label) ? value.v.label : value.v
                } }
            case 'title':
              return { icon: 'bookmark', label: 'v' }
            case 'tags':
              return { icon: 'tag', label: 'label' }
            case 'number':
              return { icon: 'pound', label: function (e) { return e.v } }
            case 'invoiceNumber':
            case 'quoteNumber':
            case 'creditNoteNumber':
              return { icon: 'pound', label: function (e) { return e } }
            case 'cancelByUser':
              return { icon: 'close-box-outline', label: 'label' }
            case 'status':
              return { icon: 'cube-send', label: 'label' }
            case 'dueDate':
              return {
                icon: 'calendar-remove',
                label: function (entity) { return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY') }
              }
            case 'signDate':
              return {
                icon: 'calendar-remove',
                label: function (entity) { return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY') }
              }
            case 'invoiceDeposit':
              return {
                icon: 'pound', label: 'label', negate: false
              }
            case 'dueDateDynamic':
              return { icon: 'calendar-remove', label: 'label' }
            case 'dateDynamic':
              return { icon: 'calendar-check', label: 'label' }
            case 'createdAtDateDynamic':
              return { icon: 'calendar-check', label: 'label' }
            case 'interval':
            case 'date':
            case 'endedAt':
            case 'createdAt':
              return {
                icon: 'calendar-check',
                label: function (entity) { return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY') }
              }
            case 'isArchived':
              return {
                icon: 'briefcase-check',
                negate: false,
                label: function (value) {
                  switch (value.value) {
                    case 'true':
                    case true:
                      return 'Archivées'
                    case 'false':
                    case false:
                      return 'Non Archivées'
                    case 'both':
                      return 'Toutes'
                  }
                }
              }
            case 'client':
            //  return {icon: 'account', label: 'v'}
              return { icon: 'account',
                label: function (value) {
                  if (_.get(value, 'label')) return value.label
                  return (value.v.label) ? value.v.label : value.v
                } }

            case 'delivery':
              return { icon: 'map-marker',
                label: function (value) {
                  if (_.get(value, 'label')) return value.label
                  return (value.v.label) ? value.v.label : value.v
                } }
            case 'priceMin':
            case 'discountedTotalHtMin':
            case 'discountMin':
            case 'fullTotalMin':
            case 'totalMin':
              return {
                icon: 'currency-eur',
                label: function (e) {
                  return $filter('numeral')(e, '0,0[.]00 $') + ' minimum'
                },
                negate: false
              }
            case 'priceMax':
            case 'discountedTotalHtMax':
            case 'discountMax':
            case 'fullTotalMax':
            case 'totalMax':
              return {
                icon: '',
                label: function (e) {
                  return $filter('numeral')(e, '0,0[.]00 $') + ' maximum'
                },
                negate: false
              }
            case 'bpu':
              return {
                icon: 'playlist-check',
                label: function (v) {
                  let label = ''
                  if (v.number) {
                    label += v.number + ' - '
                  }
                  label += v.label
                  return label
                }
              }
            case 'integratedOnChorus':
              return { icon: 'archive', label: () => { return 'Intégrée sur CHORUS' } }
            case 'chorusStatutCourant':
              return { icon: 'archive', label: (v) => { return `Statut CHORUS : ${v.label}` } }
            case 'invoiceRef':
              return { icon: 'file', label: 'title' }
            case 'interventionsCount':
              return {
                icon: 'pound',
                label: function (v) {
                  return v
                }
              }
            default:
              var customFieldFilter = $filter('customField')
              if (/customFields/.test(type)) {
                return {
                  label: function (value) {
                    if (typeof value.v === 'number' || typeof value.v === 'string') {
                      return value.label + ' : ' + customFieldFilter(value.v)
                    } else if (typeof value.v === 'boolean') {
                      var lbl = value.v ? 'vrai' : 'faux'
                      return value.label + ' : ' + lbl
                    } else if (_.get(value, 'v.start') && _.get(value, 'v.end')) {
                      return value.label + ' : ' + moment(value.v.start).format('DD/MM/YYYY') + ' - ' + moment(value.v.end).format('DD/MM/YYYY')
                    } else {
                      return value.label + ' : ' + customFieldFilter(value.v.v)
                    }
                  },
                  icon: 'pencil'
                }
              }
              return { label: '' }
          }
        }

        function getLabel (type, entity) {
          var label
          if (typeof (entity) === String) {
            return entity
          }
          if (getElement(type)) label = getElement(type).label
          if (!label) return ''
          if (typeof label === 'function') {
            return label(entity)
          }
          return label.split(' ').map(function (elt) { return _.get(entity, elt) }).join(' ')
          // return _.get(entity, getElement(type).label)
        }

        function getIcon (type, entity) {
          return getElement(type).icon
        }

        function onDrop (event, data) {
          if (!self.logic) return
          self.conditions[self.logic].push(JSON.parse(data))
          self.onChange()
        }
      }],
      compile: function (element) {
        // Break the recursion loop by removing the contents
        var contents = element.contents().remove()
        var compiledContents
        return {
          /**
           * Compiles and re-adds the contents
           */
          post: function (scope, element) {
            // Compile the contents
            if (!compiledContents) {
              compiledContents = $compile(contents)
            }
            // Re-add the compiled contents to the element
            compiledContents(scope, function (clone) {
              element.append(clone)
            })
          }
        }
      }
    }
  }
})(window.angular, window._, window.moment)
